import { Controller } from '@hotwired/stimulus';

// The mobile filter bottom sheet on /tutorials.
export default class extends Controller {
  static targets = ['sheet'];

  open() {
    this.sheetTarget.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.sheetTarget.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
  }

  // Only close when the scrim itself is tapped, not the panel inside it.
  closeOnScrim(event) {
    if (event.target === event.currentTarget) this.close();
  }

  // Each facet is rendered twice — once in the desktop rail, once in the mobile
  // sheet — and a hidden checkbox still submits. Without this, unchecking one
  // leaves its twin checked and the filter never clears.
  syncTwin(event) {
    const source = event.target;
    const twins = this.element.querySelectorAll(
      `input[type="checkbox"][name="${CSS.escape(source.name)}"][value="${CSS.escape(source.value)}"]`
    );

    twins.forEach((twin) => {
      if (twin !== source) twin.checked = source.checked;
    });
  }

  disconnect() {
    document.body.classList.remove('overflow-hidden');
  }
}
